/* eslint-disable @typescript-eslint/no-unused-vars */
import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import Loading from '../../components/loading';
import { ClassroomViewModel } from '../classroom/classroom.vm';
import MultiStep from './components/multi-step';
import Result from './components/result';

const Container = styled.div`
  width: 100%;
  font-family: 'Aprova Nova';
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-weight: normal;
  color: #111;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  height: auto;
  overflow-x: auto;
  min-height: 80vh;

  @media (max-width: 480px) {
    position: static;
  }
`;

const ContainerLoading = styled.div`
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex;
`;

interface ExercisesProps {
  showResult?: boolean;
  isLoadingExercise?: boolean;
  vm: ClassroomViewModel;
}

export const Exercises: React.FC<ExercisesProps> = ({ vm }) => {
  if (vm.isLoadingExercise) {
    return (
      <ContainerLoading>
        <Loading />
      </ContainerLoading>
    );
  }

  return (
    <Container>
      {!vm.showResult ? <MultiStep vm={vm} exercises={vm.exercises} /> : <Result vm={vm} />}
    </Container>
  );
};

export default observer(Exercises);
